import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export default function UsernameDialog({ open, onOpenChange, current, onSave }) {
  const [name, setName] = useState(current || "");
  useEffect(() => {
    if (open) setName(current || "");
  }, [open, current]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#0A0D14] border border-purple-500/40 rounded-none text-white max-w-md"
        data-testid="username-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-tight text-2xl text-glow-purple">
            Identify Hunter
          </DialogTitle>
        </DialogHeader>
        <div>
          <Label className="text-[10px] uppercase tracking-[0.3em] text-slate-400">
            Codename
          </Label>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Sung Jin-Woo"
            className="mt-1 bg-black/50 border-white/10 rounded-none focus-visible:ring-purple-500 font-display"
            data-testid="username-input"
          />
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="rounded-none border-white/20 bg-transparent text-slate-300 hover:bg-white/5"
            data-testid="username-dialog-cancel"
          >
            Cancel
          </Button>
          <Button
            disabled={!name.trim()}
            onClick={() => {
              onSave(name.trim());
              onOpenChange(false);
            }}
            className="rounded-none bg-purple-600 hover:bg-purple-500"
            data-testid="username-dialog-save"
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
